import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare, faThumbtack, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useActivityStore } from "@/stores/activityStore";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ActivitySettings',
    props: {
        query: null
    },
    setup(__props) {
        const props = __props;
        library.add({
            faCheckSquare,
            faSquare,
            faTrash,
            faThumbtack,
        });
        const activityStore = useActivityStore();
        const { activities } = storeToRefs(activityStore);
        const filteredActivities = computed(() => {
            var _a;
            if (((_a = props.query) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const queryLower = props.query.toLowerCase();
                const results = activities.value.filter((a) => {
                    const attributeValues = [a.title, a.description];
                    for (const value of attributeValues) {
                        if (value.toLowerCase().indexOf(queryLower) !== -1) {
                            return true;
                        }
                    }
                    return false;
                });
                return results;
            }
            else {
                return activities.value;
            }
        });
        const foundActivities = computed(() => {
            return filteredActivities.value.length > 0;
        });
        function onClick(activity) {
            if (activity.optional) {
                activity.visible = !activity.visible;
            }
        }
        function onRemove(activity) {
            activityStore.remove(activity.id);
        }
        return { __sfc: true, props, activityStore, activities, filteredActivities, foundActivities, onClick, onRemove, FontAwesomeIcon };
    }
});
